import "moment-timezone";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import MessagePreviewCard from "./MessagePreviewCard";

const TableNotification = ({ itemsShown, onClickRow, userLang, buttonsTB, setButtonsTB, checkAll, setCheckAll, items }) => {
    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }
        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShown.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = { ...buttonsTB };
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        buttons.topBack.disabled = items.current.chosen.length > 1 || items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                </tr>
            </thead>
            <tbody>
                {itemsShown.length === 0 ? (
                    <tr>
                        <td colSpan={2} style={{ textAlign: "center" }}>
                            No hay notificaciones
                        </td>
                    </tr>
                ) : (
                    itemsShown.map((item) => (
                        <tr key={item.id} data-idx={item.id} onClick={onClick}>
                            <td className="d-flex flex-column align-items-center gap-3" onClick={() => onClickRow(item)}>
                                <input
                                    type="checkbox"
                                    name="checkboxContainer"
                                    key={item.id}
                                    data-idx={item.id}
                                    defaultChecked={
                                        Array.isArray(items.current.chosen) ? items.current.chosen.includes(item.id) : false
                                    }
                                    readOnly={true}
                                />
                                {item.read ? "" : <FontAwesomeIcon icon={faCircle} size={"xs"} style={{ color: "#0d6efd" }} />}
                            </td>
                            <td onClick={() => onClickRow(item)} style={{ border: "none", cursor: "pointer" }}>
                                <MessagePreviewCard item={item} isSelected={String(items.current.chosen.at(-1)) === String(item.id)} userLang={userLang} />
                            </td>
                        </tr>
                    ))
                )}
            </tbody>
        </Table>
    );
};

export default TableNotification;